export const TIMESHEET_ACTION = {
  RESET_TIMESHEET_BY_ID_STATE: "RESET_TIMESHEET_BY_ID_STATE",
  REQUEST_TIMESHEET_BY_ID: "REQUEST_TIMESHEET_BY_ID",
  RESPONSE_TIMESHEET_BY_ID: "RESPONSE_TIMESHEET_BY_ID",
  ERROR_TIMESHEET_BY_ID: "ERROR_TIMESHEET_BY_ID",

  RESET_ADD_TIMESHEET_STATE: "RESET_ADD_TIMESHEET_STATE",
  REQUEST_ADD_TIMESHEET: "REQUEST_ADD_TIMESHEET",
  RESPONSE_ADD_TIMESHEET: "RESPONSE_ADD_TIMESHEET",
  ERROR_ADD_TIMESHEET: "ERROR_ADD_TIMESHEET",

  RESET_TIMESHEETS_BY_ID_FOR_USER_PAGE_STATE: "RESET_TIMESHEETS_BY_ID_FOR_USER_PAGE_STATE",
  REQUEST_TIMESHEETS_BY_ID_FOR_USER_PAGE: "REQUEST_TIMESHEETS_BY_ID_FOR_USER_PAGE",
  RESPONSE_TIMESHEETS_BY_ID_FOR_USER_PAGE: "RESPONSE_TIMESHEETS_BY_ID_FOR_USER_PAGE",
  ERROR_TIMESHEETS_BY_ID_FOR_USER_PAGE: "ERROR_TIMESHEETS_BY_ID_FOR_USER_PAGE",

  RESET_EDIT_TIMESHEETS:"RESET_EDIT_TIMESHEETS",
  REQUEST_EDIT_TIMESHEETS:"REQUEST_EDIT_TIMESHEETS",
  RESPONSE_EDIT_TIMESHEETS:"RESPONSE_EDIT_TIMESHEETS",
  ERROR_EDIT_TIMESHEETS:"ERROR_EDIT_TIMESHEETS",

  RESET_GET_TIMESHEET_BY_ID:"RESET_GET_TIMESHEET_BY_ID",
  REQUEST_GET_TIMESHEET_BY_ID:"REQUEST_GET_TIMESHEET_BY_ID",
  RESPONSE_GET_TIMESHEET_BY_ID:"RESPONSE_GET_TIMESHEET_BY_ID",
  ERROR_GET_TIMESHEET_BY_ID:"ERROR_GET_TIMESHEET_BY_ID",

  RESET_TIMESHEETS_ACTION:" RESET_TIMESHEETS_ACTION",
  REQUEST_TIMESHEETS_ACTION:"REQUEST_TIMESHEETS_ACTION",
  RESPONSE_TIMESHEETS_ACTION:"RESPONSE_TIMESHEETS_ACTION",
  ERROR_TIMESHEETS_ACTION:"ERROR_TIMESHEETS_ACTION",

  RESET_GENERATE_INVOICE:"RESET_GENERATE_INVOICE",
  REQUEST_GENERATE_INVOICE:"REQUEST_GENERATE_INVOICE",
  RESPONSE_GENERATE_INVOICE:"RESPONSE_GENERATE_INVOICE",
  ERROR_GENERATE_INVOICE:"ERROR_GENERATE_INVOICE",

    RESET_INVOICE_DOWNLOAD: "RESET_INVOICE_DOWNLOAD",
    REQUEST_DOWNLOAD_INVOICE: "REQUEST_DOWNLOAD_INVOICE",
    RESPONSE_DOWNLOAD_INVOICE: "RESPONSE_DOWNLOAD_INVOICE",
    ERROR_DOWNLOAD_INVOICE: "ERROR_DOWNLOAD_INVOICE",

    RESET_DOWNLOAD_TIMESHEET: "RESET_DOWNLOAD_TIMESHEET",
    REQUEST_DOWNLOAD_TIMESHEET: "REQUEST_DOWNLOAD_TIMESHEET",
    RESPONSE_DOWNLOAD_TIMESHEET: "RESPONSE_DOWNLOAD_TIMESHEET",
    ERROR_DOWNLOAD_TIMESHEET: "ERROR_DOWNLOAD_TIMESHEET",

    RESET_TIMESHEET_LIST_STATE: 'RESET_TIMESHEET_LIST_STATE',
    REQUEST_TIMESHEET_LIST:"REQUEST_TIMESHEET_LIST",
    RESPONSE_TIMESHEET_LIST:"RESPONSE_TIMESHEET_LIST",
    ERROR_TIMESHEET_LIST:"ERROR_TIMESHEET_LIST",

    RESET_TIMESHEET_APP_STATE: 'RESET_TIMESHEET_APP_STATE',
    REQUEST_TIMESHEET_APP:"REQUEST_TIMESHEET_APP",
    RESPONSE_TIMESHEET_APP:"RESPONSE_TIMESHEET_APP",
    ERROR_TIMESHEET_APP:"ERROR_TIMESHEET_APP",

    RESET_REJECTED_TIMESHEET_LIST_STATE: 'RESET_REJECTED_TIMESHEET_LIST_STATE',
    REQUEST_REJECTED_TIMESHEET_LIST:"REQUEST_REJECTED_TIMESHEET_LIST",
    RESPONSE_REJECTED_TIMESHEET_LIST:"RESPONSE_REJECTED_TIMESHEET_LIST",
    ERROR_REJECTED_TIMESHEET_LIST:"ERROR_REJECTED_TIMESHEET_LIST",

    RESET_TOBEINVOICED_TIMESHEET_LIST_STATE: 'RESET_TOBEINVOICED_TIMESHEET_LIST_STATE',
    REQUEST_TOBEINVOICED_TIMESHEET_LIST:"REQUEST_TOBEINVOICED_TIMESHEET_LIST",
    RESPONSE_TOBEINVOICED_TIMESHEET_LIST:"RESPONSE_TOBEINVOICED_TIMESHEET_LIST",
    ERROR_TOBEINVOICED_TIMESHEET_LIST:"ERROR_TOBEINVOICED_TIMESHEET_LIST",

    RESET_DOWNLOAD_FILE_BY_ID:"RESET_DOWNLOAD_FILE_BY_ID",
  REQUEST_DOWNLOAD_FILE_BY_ID:"REQUEST_DOWNLOAD_FILE_BY_ID",
  RESPONSE_DOWNLOAD_FILE_BY_ID:"RESPONSE_DOWNLOAD_FILE_BY_ID",
  ERROR_DOWNLOAD_FILE_BY_ID:"ERROR_DOWNLOAD_FILE_BY_ID",


  RESET_TOBEINVOICED_TIMESHEET_LIST_BY_EMPLOYEE_AND_PROJECT_STATE: 'RESET_TOBEINVOICED_TIMESHEET_LIST_BY_EMPLOYEE_AND_PROJECT_STATE',
  REQUEST_TOBEINVOICED_TIMESHEET_LIST_BY_EMPLOYEE_AND_PROJECT:"REQUEST_TOBEINVOICED_TIMESHEET_LIST_BY_EMPLOYEE_AND_PROJECT",
  RESPONSE_TOBEINVOICED_TIMESHEET_LIST_BY_EMPLOYEE_AND_PROJECT:"RESPONSE_TOBEINVOICED_TIMESHEET_LIST_BY_EMPLOYEE_AND_PROJECT",
  ERROR_TOBEINVOICED_TIMESHEET_LIST_BY_EMPLOYEE_AND_PROJECT:"ERROR_TOBEINVOICED_TIMESHEET_LIST_BY_EMPLOYEE_AND_PROJECT",
};

export const setResetStatedownloadTimeSheet = () => ({
  type: TIMESHEET_ACTION.RESET_DOWNLOAD_TIMESHEET,
  data: undefined
});

export const requestDownloadTimeSheetAction = (payload) =>({
  type: TIMESHEET_ACTION.REQUEST_DOWNLOAD_TIMESHEET,
  data: payload
})
export const responseDownloadTimeSheetAction = (res) => ({
  type: TIMESHEET_ACTION.RESPONSE_DOWNLOAD_TIMESHEET,
  data: res
});

export const errorDownloadTimeSheetAction = (err) => ({
  type: TIMESHEET_ACTION.ERROR_DOWNLOAD_TIMESHEET,
  data: err
});


export const setResetStatedownloadInvoice = () => ({
  type: TIMESHEET_ACTION.RESET_INVOICE_DOWNLOAD,
  data: undefined
});

export const requestDownloadInvoiceAction = (payload) =>({
  type: TIMESHEET_ACTION.REQUEST_DOWNLOAD_INVOICE,
  data: payload
})
export const responseDownloadInvoiceAction = (res) => ({
  type: TIMESHEET_ACTION.RESPONSE_DOWNLOAD_INVOICE,
  data: res
});

export const errorDownloadInvoiceAction = (err) => ({
  type: TIMESHEET_ACTION.ERROR_DOWNLOAD_INVOICE,
  data: err
});



export const setResetGenerateInvoice = () => ({
  type: TIMESHEET_ACTION.RESET_GENERATE_INVOICE,
  data: undefined 
});

export const requestGenerateInvoice = (payload) =>({
  type:TIMESHEET_ACTION.REQUEST_GENERATE_INVOICE,
  data: payload
})
export const responseGenerateInvoice = (res) => ({
  type: TIMESHEET_ACTION.RESPONSE_GENERATE_INVOICE,
  data: res
});

export const errorGenerateInvoice = (err) => ({
  type: TIMESHEET_ACTION.ERROR_GENERATE_INVOICE,
  data: err
});


export const setResetTimesheetsAction = () => ({
  type: TIMESHEET_ACTION.RESET_TIMESHEETS_ACTION,
  data: undefined
});

export const requestTimesheetsAction = (params) =>({
  type:TIMESHEET_ACTION.REQUEST_TIMESHEETS_ACTION,
  data: params
})
export const responseTimesheetsAction = (res) => ({
  type: TIMESHEET_ACTION.RESPONSE_TIMESHEETS_ACTION,
  data: res
});

export const errorTimesheetsAction = (err) => ({
  type: TIMESHEET_ACTION.ERROR_TIMESHEETS_ACTION,
  data: err
});


export const setResetGetTimesheetById = () => ({
  type: TIMESHEET_ACTION.RESET_GET_TIMESHEET_BY_ID,
  data: undefined
});

export const requestGetTimesheetById = (params) =>({
  type:TIMESHEET_ACTION.REQUEST_GET_TIMESHEET_BY_ID,
  data: params
})
export const responseGetTimesheetById = (res) => ({
  type: TIMESHEET_ACTION.RESPONSE_GET_TIMESHEET_BY_ID,
  data: res
});

export const errorGetTimesheetById = (err) => ({
  type: TIMESHEET_ACTION.ERROR_GET_TIMESHEET_BY_ID,
  data: err
});

export const setResetEditTimesheets = () => ({
  type: TIMESHEET_ACTION.RESET_EDIT_TIMESHEETS,
  data: undefined
});

export const requestEditTimesheets = (params) =>({
  type:TIMESHEET_ACTION.REQUEST_EDIT_TIMESHEETS,
  data: params
})
export const responseEditTimesheets = (res) => ({
  type: TIMESHEET_ACTION.RESPONSE_EDIT_TIMESHEETS,
  data: res
});

export const errorEditTimesheets = (err) => ({
  type: TIMESHEET_ACTION.ERROR_EDIT_TIMESHEETS,
  data: err
});

export const setResetStateTimesheetById = () => ({
  type: TIMESHEET_ACTION.RESET_TIMESHEET_BY_ID_STATE,
  data: undefined,
});

export const requestTimesheetById = (params) => ({
  type: TIMESHEET_ACTION.REQUEST_TIMESHEET_BY_ID,
  data: params,
});
export const responseTimesheetById = (res) => ({
  type: TIMESHEET_ACTION.RESPONSE_TIMESHEET_BY_ID,
  data: res,
});

export const errorTimesheetById = (err) => ({
  type: TIMESHEET_ACTION.ERROR_TIMESHEET_BY_ID,
  data: err,
});


export const setResetStateTimesheetsByIdForUserPage = () => ({
  type: TIMESHEET_ACTION.RESET_TIMESHEETS_BY_ID_FOR_USER_PAGE_STATE,
  data: undefined,
});

export const requestTimesheetsByIdForUserPage = (params) => ({
  type: TIMESHEET_ACTION.REQUEST_TIMESHEETS_BY_ID_FOR_USER_PAGE,
  data: params,
});
export const responseTimesheetsByIdForUserPage = (res) => ({
  type: TIMESHEET_ACTION.RESPONSE_TIMESHEETS_BY_ID_FOR_USER_PAGE,
  data: res,
});

export const errorTimesheetsByIdForUserPage = (err) => ({
  type: TIMESHEET_ACTION.ERROR_TIMESHEETS_BY_ID_FOR_USER_PAGE,
  data: err,
});



export const setResetAddTimesheet = () => ({
  type: TIMESHEET_ACTION.RESET_ADD_TIMESHEET_STATE,
  data: undefined,
});

export const requestAddTimesheet = (params) => ({
  type: TIMESHEET_ACTION.REQUEST_ADD_TIMESHEET,
  data: params,
});
export const responseAddTimesheet = (res) => ({
  type: TIMESHEET_ACTION.RESPONSE_ADD_TIMESHEET,
  data: res,
}); 

export const errorAddTimesheet = (err) => ({
  type: TIMESHEET_ACTION.ERROR_ADD_TIMESHEET,
  data: err,
});


export const setResetStateTimesheetList = () => ({
  type: TIMESHEET_ACTION.RESET_TIMESHEET_LIST_STATE,
  data: undefined
});

export const requestTimesheetListAction = (params) =>({
  type:TIMESHEET_ACTION.REQUEST_TIMESHEET_LIST,
  data: params
})
export const responseTimesheetListAction = (res) => ({
  type: TIMESHEET_ACTION.RESPONSE_TIMESHEET_LIST,
  data: res
});

export const errorTimesheetListAction = (err) => ({
  type: TIMESHEET_ACTION.ERROR_TIMESHEET_LIST,
  data: err
});


export const setResetStateTimesheetApp = () => ({
  type: TIMESHEET_ACTION.RESET_TIMESHEET_APP_STATE,
  data: undefined
});

export const requestTimesheetAppAction = (params) =>({
  type:TIMESHEET_ACTION.REQUEST_TIMESHEET_APP,
  data: params
})
export const responseTimesheetAppAction = (res) => ({
  type: TIMESHEET_ACTION.RESPONSE_TIMESHEET_APP,
  data: res
});

export const errorTimesheetAppAction = (err) => ({
  type: TIMESHEET_ACTION.ERROR_TIMESHEET_APP,
  data: err
});

export const setResetStateRejectedTimesheetList = () => ({
  type: TIMESHEET_ACTION.RESET_REJECTED_TIMESHEET_LIST_STATE,
  data: undefined
});

export const requestRejectedTimesheetListAction = (params) =>({
  type:TIMESHEET_ACTION.REQUEST_REJECTED_TIMESHEET_LIST,
  data: params
})
export const responseRejectedTimesheetListAction = (res) => ({
  type: TIMESHEET_ACTION.RESPONSE_REJECTED_TIMESHEET_LIST,
  data: res
});

export const errorRejectedTimesheetListAction = (err) => ({
  type: TIMESHEET_ACTION.ERROR_REJECTED_TIMESHEET_LIST,
  data: err
});

export const setResetStateToBeInvoicedTimesheetList = () => ({
  type: TIMESHEET_ACTION.RESET_TOBEINVOICED_TIMESHEET_LIST_STATE,
  data: undefined
});

export const requestToBeInvoicedTimesheetListAction = (params) =>({
  type:TIMESHEET_ACTION.REQUEST_TOBEINVOICED_TIMESHEET_LIST,
  data: params
})
export const responseToBeInvoicedTimesheetListAction = (res) => ({
  type: TIMESHEET_ACTION.RESPONSE_TOBEINVOICED_TIMESHEET_LIST,
  data: res
});

export const errorToBeInvoicedTimesheetListAction = (err) => ({
  type: TIMESHEET_ACTION.ERROR_TOBEINVOICED_TIMESHEET_LIST,
  data: err
});

export const setResetDownloadFileById = () => ({
  type: TIMESHEET_ACTION.RESET_DOWNLOAD_FILE_BY_ID,
  data: undefined
});

export const requestDownloadFileById = (params) => ({
  type: TIMESHEET_ACTION.REQUEST_DOWNLOAD_FILE_BY_ID,
  data: params
});

export const responseDownloadFileById = (res) => ({
  type: TIMESHEET_ACTION.RESPONSE_DOWNLOAD_FILE_BY_ID,
  data: res
});

export const errorDownloadFileById = (err) => ({
  type: TIMESHEET_ACTION.ERROR_DOWNLOAD_FILE_BY_ID,
  data: err
});


export const setResetStateToBeInvoicedTimesheetListByEmployeeAndProject = () => ({
  type: TIMESHEET_ACTION.RESET_TOBEINVOICED_TIMESHEET_LIST_BY_EMPLOYEE_AND_PROJECT_STATE,
  data: undefined
});
export const requestToBeInvoicedTimesheetListByEmployeeAndProject = (params) => ({
  type: TIMESHEET_ACTION.REQUEST_TOBEINVOICED_TIMESHEET_LIST_BY_EMPLOYEE_AND_PROJECT,
  data: params
});
export const responseToBeInvoicedTimesheetListByEmployeeAndProject = (res) => ({
  type: TIMESHEET_ACTION.RESPONSE_TOBEINVOICED_TIMESHEET_LIST_BY_EMPLOYEE_AND_PROJECT,
  data: res
});
export const errorToBeInvoicedTimesheetListByEmployeeAndProject = (err) => ({
  type: TIMESHEET_ACTION.ERROR_TOBEINVOICED_TIMESHEET_LIST_BY_EMPLOYEE_AND_PROJECT,
  data: err
});